/**
 * Wann eine Tabelle einen Seitenwechsel nach außen meldet.
 *
 * TanStack setzt die Seite von sich aus zurück, sobald sich die Daten ändern — auch dann, wenn sie
 * schon auf der ersten steht. Meldet die Tabelle das ungeprüft weiter und legt der Aufrufer die
 * Seite in die Adresse, entsteht ein Kreis: Adresse ändert sich, Tabelle rendert, Rücksetzung
 * meldet, Adresse ändert sich. Chrome bremst das irgendwann selbst aus — „Throttling navigation to
 * prevent the browser from hanging" — und bis dahin ist die Seite nicht zu bedienen.
 *
 * Der Kreis bricht an einer Stelle, an der ohnehin nichts verloren geht: **Gemeldet wird nur, was
 * die Seite wirklich ändert.**
 */

/**
 * Die zu meldende Seitenzahl (1-basiert) — oder `null`, wenn nichts zu melden ist.
 *
 * Beide Zahlen kommen 0-basiert herein, so wie TanStack sie führt.
 */
export const pageChangeToReport = (
    currentPageIndex: number,
    nextPageIndex: number,
): number | null => (nextPageIndex === currentPageIndex ? null : nextPageIndex + 1);
